// Website / change() persist these in pence. Portal create historically stored
// some of them already in pounds, so blindly dividing by 100 shows £3.17 for £317.
export const storedMoneyToPounds = (value, totalPricePence) => {
  const n = Number(value)
  if (!Number.isFinite(n) || n === 0) return 0
  if (Math.abs(n) >= 1000) return n / 100
  const total = Number(totalPricePence)
  if (Number.isFinite(total) && total > 0 && n >= 100) {
    const sameScaleAsTotal = total < 1000 ? n >= total * 0.5 : n >= total * 0.05
    if (sameScaleAsTotal) return n / 100
  }
  return n
}
